import { Feature, Point, Polygon } from "geojson";
import { POLYGON_COLORS } from "./JobMap.types";

/**
 * Get a random color from the polygon colors palette
 */
export function getRandomPolygonColor(): string {
	const index = Math.floor(Math.random() * POLYGON_COLORS.length);
	return POLYGON_COLORS[index];
}

/**
 * Get a consistent color for a job based on its ID.
 * Uses a simple hash function to map the job ID to a stable color index.
 */
export function getJobColor(jobId: string): string {
	let hash = 0;
	for (let i = 0; i < jobId.length; i++) {
		const char = jobId.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash; // Convert to 32-bit integer
	}
	const index = Math.abs(hash) % POLYGON_COLORS.length;
	return POLYGON_COLORS[index];
}

/**
 * Safely extract a property from a GeoJSON feature
 */
export function getShapeFeatureProperty(feature: Feature<Polygon | Point>, key: string): string {
	return feature.properties && key in feature.properties ? feature.properties[key] : "";
}

/**
 * Parse the change value from feature properties
 */
export function parseChangeInfo(change: string): {
	hasChange: boolean;
	changeType: string;
	changeReason: string;
} {
	const [changeType, changeReason] = change.includes(":") ? change.split(":") : ["", ""];
	const hasChange = Boolean(changeType && changeType !== "None");
	return { hasChange, changeType, changeReason: changeReason || "" };
}

/**
 * Check if a marker position is visible within the current bounds and zoom level
 */
export function isMarkerVisible(
	position: google.maps.LatLngLiteral,
	bounds: google.maps.LatLngBounds,
	zoom: number | undefined,
	zoomThreshold: number | undefined,
): boolean {
	if (!zoom || !zoomThreshold || zoom < zoomThreshold) {
		return false;
	}
	return bounds.contains(new google.maps.LatLng(position.lat, position.lng));
}
